const formatDateForServer = (date: string | undefined) => {
  if (date) {
    return new Date(date.concat('T00:00:00')).toISOString();
  }

  return '';
};

export { formatDateForServer };
